import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';

const business: AppRouteModule = {
  path: '/business',
  name: 'Business',
  component: LAYOUT,
  redirect: '/business/index',
  meta: {
    icon: 'icon-park-outline:clue',
    title: '商机列表',
    hideChildrenInMenu: true,
    auth: 'business',
    orderNo: 40,
  },
  children: [
    {
      path: 'index',
      name: 'BusinessIndex',
      component: () => import('/@/views/admin/business/index.vue'),
      meta: {
        title: '商机列表',
        hideMenu: true,
        ignoreKeepAlive: false,
        setting: {
          action: 'index',
          controller: 'business',
          module: 'crm',
          types: 'crm_business',
        },
        auth: 'business.index',
      },
    },
    {
      path: 'detail/:id',
      name: 'BusinessDetail',
      component: () => import('/@/views/admin/business/BusinessDetail.vue'),
      meta: {
        title: '商机详情',
        hideMenu: true,
        ignoreKeepAlive: true,
        currentActiveMenu: '/business/index',
        setting: {
          action: 'read',
          controller: 'business',
          module: 'crm',
          types: 'crm_business',
        },
        auth: 'business.read',
      },
    },
  ],
};

export default business;
